import type { TFunction } from "i18next";
import { z } from "zod";

const createUrlFieldSchema = (t: TFunction) =>
  z
    .string()
    .trim()
    .refine(
      (value) => {
        if (value.length === 0) {
          return true;
        }

        return z.url().safeParse(value).success;
      },
      {
        message: t("common.appLinksSettings.validation.invalidUrl"),
      },
    );

export const createAppLinksSchema = (t: TFunction) => {
  const urlFieldSchema = createUrlFieldSchema(t);

  return z.object({
    tenantKnowledgeBaseUrl: urlFieldSchema,
    tenantCustomerSupportUrl: urlFieldSchema,
    frontDeskKnowledgeBaseUrl: urlFieldSchema,
    frontDeskCustomerSupportUrl: urlFieldSchema,
    adminKnowledgeBaseUrl: urlFieldSchema,
    adminCustomerSupportUrl: urlFieldSchema,
    staffKnowledgeBaseUrl: urlFieldSchema,
    staffCustomerSupportUrl: urlFieldSchema,
    guestKnowledgeBaseUrl: urlFieldSchema,
    guestCustomerSupportUrl: urlFieldSchema,
  });
};

export type AppLinksFormValues = z.infer<
  ReturnType<typeof createAppLinksSchema>
>;
